/**
 * Retorna a tradução correspondente ao idioma no localStorage.
 *
 * Este método converte a string JSON fornecida num objeto e retorna a tradução
 * correspondente ao idioma armazenado no localStorage. Se o idioma não for encontrado,
 * retorna a tradução padrão em português ('pt').
 *
 * @param {string} json - A string JSON com as traduções para os diferentes idiomas.
 * Exemplo: '{"pt": "Produto", "en": "Product", "es": "Producto"}'
 *
 * @returns {string} - A tradução correspondente ao idioma armazenado no localStorage.
 * Exemplo: "Produto" se localStorage.getItem("lang") === 'pt'
 */
export function __translate(json) {
  try {
    const translations = JSON.parse(json);
    const lang = localStorage.getItem("lang") || "pt";
    return translations[lang] || translations["pt"]; // Retorna a tradução ou 'pt' como fallback
  } catch (error) {
    console.error("Erro ao processar a tradução:", error);
    return json;
  }
}
